module.exports = __webpack_public_path__ + "img/670.3f014fa4.jpg";